import React from 'react'

import { isIEBrowser, isEdgeBrowser, isSafari  } from '../../utils';

export default function toTop() {
  let offTop = document.querySelector(".page-wrapper").getBoundingClientRect().top + window.pageYOffset;
  if (isIEBrowser() || isEdgeBrowser() || isSafari()) {
      let pos = window.pageYOffset;
      let timer = setInterval(() => {
          if (pos <= offTop) {
              if (pos < offTop - 40 && pos <= offTop) {
                  window.scrollTo({
                      top: offTop - 90
                  })
                  clearInterval(timer);
              } else {
                  window.scrollBy(0, 40);
                  pos += 40;
              }

              window.scrollTo({
                  top: offTop - 90
              })
              clearInterval(timer);
          }

          if (pos >= offTop) {
              if (pos < offTop + 40 && pos >= offTop) {
                  window.scrollTo({
                      top: offTop - 90
                  })
                  clearInterval(timer);
              } else {
                  window.scrollBy(0, -40);
                  pos -= 40;
              }
          }
      }, 1);
  } else {
      window.scrollTo({
          top: offTop - 90,
          behavior: "smooth"
      })
  }
}